<h2
    class="custom-title pl-3 text-gray-700 font-bold text-lg lg:text-2xl dark:text-white"
    [style.--custom-title-color]="color || null"
>
    {{ title }}
</h2>
